import { formatNumber } from '../helpers/numbers';

const format = (dimension) => dimension && dimension.value !== null && dimension.unit && `${formatNumber(dimension.value)} ${dimension.unit}`;

export default format;
